var map = {
	"./aichi.png": "ebab",
	"./akita.png": "ef94",
	"./aomori.png": "e6dd",
	"./chiba.png": "57cd",
	"./dento_roulette_anime.gif": "9798",
	"./ehime.png": "6dfc",
	"./fukui.png": "5d62",
	"./fukuoka.png": "ff55",
	"./fukushima.png": "c395",
	"./gifu.png": "989e",
	"./gunma.png": "39b5",
	"./hiroshima.png": "cd14",
	"./hokkaido.png": "3423",
	"./hyogo.png": "0b8c",
	"./ibaraki.png": "dd06",
	"./ishikawa.png": "b729",
	"./iwate.png": "2f4d",
	"./kagawa.png": "a6bf",
	"./kagoshima.png": "3412",
	"./kanagawa.png": "7b91",
	"./kochi.png": "a6f5",
	"./kumamoto.png": "481c",
	"./kyoto.png": "f5d4",
	"./mie.png": "e195",
	"./miyagi.png": "bc1d",
	"./miyazaki.png": "be24",
	"./nagano.png": "c6e2",
	"./nagasaki.png": "8be9",
	"./nara.png": "f202",
	"./niigata.png": "569d",
	"./oita.png": "d43f",
	"./okayama.png": "5e89",
	"./okinawa.png": "ed40",
	"./osaka.png": "e314",
	"./saga.png": "61a4",
	"./saitama.png": "f4de",
	"./shiga.png": "ac4d",
	"./shimane.png": "5f5a",
	"./shizuoka.png": "2fa9",
	"./tochigi.png": "856d",
	"./tokushima.png": "4cc1",
	"./tokyo.png": "082d",
	"./tottori.png": "db8d",
	"./toyama.png": "1667",
	"./wakayama.png": "bd24",
	"./yamagata.png": "8371",
	"./yamaguchi.png": "a18e",
	"./yamanashi.png": "8c81"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b620";